import { useEffect, useState } from 'react';
import { Badge, Button, Panel } from '@usacow/ds';
import { api, type IssueReport } from '../../lib/api';

export function QAQueue() {
  const [issues, setIssues] = useState<IssueReport[] | null>(null);
  const [status, setStatus] = useState('open');

  async function load(s: string) {
    const r = await api.adminIssues(s);
    setIssues(r.issues);
  }
  useEffect(() => {
    void load(status);
  }, [status]);

  async function resolve(id: string) {
    await api.adminResolve(id, 'reviewed').catch(() => {});
    await load(status);
  }

  return (
    <div className="scr">
      <div className="scr-head">
        <div>
          <div className="t-eyebrow">content-ops · QA</div>
          <h1 className="scr-h">Issue queue</h1>
        </div>
        <div className="adm-tabs">
          {['open', 'resolved'].map((s) => (
            <button
              key={s}
              className={`adm-tab${status === s ? ' is-on' : ''}`}
              onClick={() => setStatus(s)}
            >
              {s}
            </button>
          ))}
        </div>
      </div>

      <Panel title={`${status} issues`}>
        {!issues ? (
          <div className="dim">Loading…</div>
        ) : issues.length === 0 ? (
          <p className="dim">Nothing here.</p>
        ) : (
          <div className="adm-issues">
            {issues.map((i) => (
              <div className="adm-issue" key={i.id}>
                <div>
                  <div className="adm-issue__top">
                    <Badge tone={i.severity === 'high' ? 'incorrect' : 'warning'} variant="outline">
                      {i.category}
                    </Badge>
                    <span className="mono dim">{i.scenario_id}</span>
                  </div>
                  {i.note && <div className="adm-issue__note">{i.note}</div>}
                </div>
                {i.status === 'open' && (
                  <Button variant="secondary" size="sm" onClick={() => resolve(i.id)}>
                    Resolve
                  </Button>
                )}
              </div>
            ))}
          </div>
        )}
      </Panel>
    </div>
  );
}
